// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import App from './App';
import ThemeProvider from './layouts/ThemeProvider';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/datepicker-dark.css';

// Select the root element where you want to render your app
const container = document.getElementById('root');

// Create a root and render the app inside it
const root = createRoot(container); // Use createRoot in React 18

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register service worker for push notifications + offline PWA caching.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('SW registered:', reg.scope);
        // Poll for updates occasionally so a new deploy's shell is picked up.
        setInterval(() => { reg.update().catch(() => {}); }, 60 * 60 * 1000);
      })
      .catch(err => console.log('SW registration failed:', err));

    // When a NEW SW replaces an existing one (a redeploy), reload once so the
    // freshly-deployed hashed assets are used. Skip on first-ever install
    // (no prior controller) and guard against reload loops.
    const hadController = !!navigator.serviceWorker.controller;
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing || !hadController) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
